module.exports = __webpack_public_path__ + "media/images/icons/lock-unlocked-e976a38c7c5a71139b1c3cf861e013d3.svg";